import { Control, Controller, RegisterOptions } from "react-hook-form";
import { Radio, RadioProps } from "antd";

interface FormRadioProps extends Omit<RadioProps, "checked" | "onChange"> {
  name: string;
  control: Control<any>;
  rules?: RegisterOptions;
  compareValue?: any; // The value to compare against for checked state
}

export const FormRadio = ({ name, control, rules, compareValue, ...props }: FormRadioProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <Radio 
          {...props} 
          checked={field.value === compareValue}
          onChange={(e) => {
            if (e.target.checked && compareValue !== undefined) {
              field.onChange(compareValue);
            } else {
              field.onChange(e.target.checked);
            }
          }}
        />
      )}
    />
  );
};
